import i18n from '@/i18n/i18n';

/**
 * Validation result for file validation
 */
export interface FileValidationResult {
  valid: boolean;
  error?: string;
}

/**
 * Validates a GEDCOM file
 * @param file - The file to validate
 * @param maxSizeMB - Maximum file size in MB (default: 10)
 * @returns Validation result with valid flag and optional error message
 */
export function validateGedcomFile(file: File, maxSizeMB: number = 10): FileValidationResult {
  // Validate file type. A .gdz is a GEDCOM 7 bundle; we read the GEDCOM inside it.
  const name = file.name.toLowerCase();
  if (!name.endsWith('.ged') && !name.endsWith('.gdz')) {
    return {
      valid: false,
      error: i18n.t('screens:uploadGedcom.errors.invalidGedcomType')
    };
  }

  // Validate file size (default max 10MB)
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  if (file.size > maxSizeBytes) {
    return {
      valid: false,
      error: i18n.t('screens:uploadGedcom.errors.fileTooLarge', { maxMb: maxSizeMB })
    };
  }

  return { valid: true };
}
